import { useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Typography } from 'antd';

import { DemoSettingsForm } from 'Components';
import { useDemoList } from 'Providers';

import './styles.scss';

export function DemoSettings() {
  const { demoIndex } = useParams<{ demoIndex: string }>();
  const history = useHistory();
  const { demoList, updateDemoList } = useDemoList();
  const settings = demoList.data[Number(demoIndex)];

  const onSubmit = useCallback(
    (update: Record<string, any>) => {
      updateDemoList(Number(demoIndex), update);
      history.push(`/play/${demoIndex}`);
    },
    [demoIndex, updateDemoList, history]
  );
  const teamsIndex = settings.fields.findIndex(({ name }) => name === 'team');

  if (teamsIndex !== -1) {
    const filteredTeams = (settings.fields[teamsIndex].options ?? []).filter(
      ({ extras }) => Array.isArray(extras?.demoFlow) && extras.demoFlow.includes(settings.demoType)
    );

    settings.fields[teamsIndex].options = filteredTeams;
    settings.fields[teamsIndex].value = filteredTeams[0];
  }

  if (!settings) {
    return null;
  }

  return (
    <div className="settings">
      <Typography.Title level={2}>{settings.name} demo settings</Typography.Title>
      <DemoSettingsForm settings={settings} onSubmit={onSubmit} />
    </div>
  );
}
